import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import Page from "@insite/mobius/Page";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface HomeStyles {
    mainContainer?: InjectableCss;
}

const styles: HomeStyles = {
    mainContainer: {
        css: css`
            margin-top: -1px;
            div[data-test-selector="rowsContainer"] {
                max-width: 100%;
                div[data-test-selector="rows"] {
                    &:nth-child(odd) {
                        background: ${getColor("common.accent")};
                    }
                }
                div[data-test-selector="rows"]:first-child {
                    > div[class^="Wrapper"] {
                        > div[class^="sc"] {
                            padding-top: 0;
                        }
                    }
                }
            }
            div[data-test-selector="brandGallery"] {
                h1[data-test-selector="brandGalleryTitle"] {
                    margin-top: 18px;
                }
                div[class^="FlexWrapContainer"] {
                    max-width: 1440px;
                    padding: 10px;
                    margin: 15px auto 35px;
                }
            }
        `,
    },
};

const HomePage = ({ id }: PageProps) => (
    <Page data-test-selector="homePage" fullWidth={[true, true, true, true, true]} {...styles.mainContainer}>
        <Zone contentId={id} zoneName="Content" requireRows />
        <AddToListModal />
    </Page>
);

const pageModule: PageModule = {
    component: HomePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: false,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "HomePage" instead of this constant.
 */
export const HomePageContext = "HomePage";
